export default __webpack_public_path__ + "static/media/clusterZoneIcon.35c20434.png";